import { createSelector } from 'reselect';
import { returnJS } from 'utils/helpers';
import { initialState } from './reducer';

const selectAdminRoiListDomain = (state) =>
	state.get('adminRoiList', initialState);

export const makeSelectAdminRois = () =>
	createSelector(selectAdminRoiListDomain, (substate) =>
		returnJS(substate.get('rois')),
	);

export const makeSelectAdminRoisTotal = () =>
	createSelector(selectAdminRoiListDomain, (substate) =>
		substate.get('total'),
	);

export const makeSelectAdminRoisLoading = () =>
	createSelector(selectAdminRoiListDomain, (substate) =>
		substate.get('loading'),
	);

export const makeSelectAdminRoisSubmitting = () =>
	createSelector(selectAdminRoiListDomain, (substate) =>
		substate.get('submitting'),
	);
